import Vue from 'vue'
import App from './App.vue'
import store from './store'
import { Toast} from 'vant'
import VueScroller from 'vue-scroller'
import { Cell, CellGroup } from 'vant';
import { Popup } from 'vant';
import { Picker } from 'vant';
import { Calendar } from 'vant';
import { Button } from 'vant';
import { List } from 'vant';
import { DatetimePicker } from 'vant';
import { Dialog } from 'vant';
import { Checkbox, CheckboxGroup } from 'vant';
import { Search } from 'vant';
import '../node_modules/vant/lib/index.css';
import AMap from 'vue-amap';
import { Loading } from 'vant';

Vue.use(AMap)
AMap.initAMapApiLoader({
  key: '7f1cbfeadfb7140a2d8e9864f06dd2da',
  plugin: [
    // 插件
    'AMap.Autocomplete',//自动补齐
    'AMap.PlaceSearch',//地点搜索
    'AMap.Scale',//没用过
    'AMap.OverView',//没用过
    'AMap.ToolBar',//没用过
    'AMap.MapType',//没用过
    'AMap.PolyEditor',//没用过
    "AMap.Geolocation", //定位
    "AMap.Geocoder",//地址转码
    "AMapUI.loadUI",//加载UI
    "AMap.InfoWindow",//信息窗
    "AMap.CircleEditor"//圆形区域
  ],
  // 默认高德 sdk 版本为 1.4.15
  v: '1.4.15'
});


Vue.use(DatetimePicker);
Vue.use(List);
Vue.use(Button);
Vue.use(Calendar);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Toast);
Vue.use(VueScroller);
Vue.use(Dialog);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Search);
Vue.use(Loading);

Vue.config.productionTip = false


new Vue({
  store,
  beforeCreate() {
    Vue.prototype.$bus=this
  },
  render: h => h(App),
}).$mount('#app')
